export default function () {
  const widgetName = 'contentBlockModule';
  const widgetOpts = contentBlockModuleOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customWidget() {

        $(`#${widgetName} .card-widget-item`).each(function (x) {
          let jobTitle = `${slide.items[x].DetailLinkText}`

          $(this).find('.buttonwrap a').addClass('button')
          $(this).find('.button').removeClass('moreButton ')
          $(this).find('.button').attr('target', '')
          

          $(this).find(".image-container, .image-container img").attr({
            "data-aos": "fade-left",
            "data-aos-easing": "ease-in-out",
            "data-aos-duration": "800",
            "data-aos-delay": "200",
            "data-aos-once": "true",
            "data-aos-offset": "300"
          })
        })
      }

      customWidget()
      
    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'Register Now'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });
}